<template>
  <div class="container-fluid col-12 col-lg-10" id="container">

    <div class="calculadora-cabecalho">
      <nav class="breadcrumb-calculadora" style="--bs-breadcrumb-divider: url(&#34;data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8'%3E%3Cpath d='M2.5 0L1 1.5 3.5 4 1 6.5 2.5 8l4-4-4-4z' fill='%236c757d'/%3E%3C/svg%3E&#34;);" aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <router-link to="/" class="text-decoration-none">
            <b class="page-header-eyebrow">Projetos</b>
          </router-link>
        </li>
        <li class="breadcrumb-item">
          <router-link
            :to="`/app/project/${calculo.codProjeto}`"
            class="text-decoration-none"
          >
            <b class="page-header-eyebrow">Projeto</b>
          </router-link>
        </li>    
        <li class="breadcrumb-item active" aria-current="page">Componente</li>
      </ol>
      </nav>
      <div class="badges-calculadora">
        <span class="azul badge bg-primary"><b>Data de Criação: {{ converterDataBrasil(calculo.dataCriacao) }}</b></span>
        <span class="azul badge bg-primary"><b>Autor(a): {{ abreviarNome(calculo.autor) }}</b></span>
      </div>
    </div>

    <section class="calculadora-resumo">
      <!-- TÍTULO -->
      <div class="calculadora-identificacao">
        <p class="page-header-eyebrow">COMPONENTE DE CASCO</p>
        <h1 class="calculadora-titulo">{{ calculo.nomeCalculo }}</h1>
        <p class="calculadora-subtitulo">
          Calculadora: <strong>{{ calculo.nomeCalculadora }}</strong>
        </p>
      </div>

      <figure class="calculadora-ilustracao">
        <img
          src="../componentes/img/4.png"
          alt="Desenho do Componente"
          class="img-componente-calc"
        />
        <figcaption>Ilustração do componente</figcaption>
      </figure>
    </section>

    <section class="calculadora-impressao">
      <div>
        <h2>Imprimir componente</h2>
        <p>Imprime um PDF com todos os dados do componente.</p>
      </div>
      <button type="button" class="btn btn-secundario" @click="imprimir()">
        Imprimir
      </button>
    </section>

    <!-- BOTÕES DE AÇÃO -->
    <div class="row g-2 justify-content-end">

      <!-- RESULTADOS -->
      <div class="col-12 col-md-auto">
        <button
          type="submit"
          class="botao-azul btn btn-primary w-100"
          @click="verResultados()"
        >
          <!-- <i class="ti ti-calculator"></i> -->
          Ver Resultados
        </button>
      </div>

      <!-- CALCULAR -->
      <div class="col-12 col-md-auto">
        <button
          type="button"
          class="botao-azul btn btn-primary w-100"
          @click="calcular"
        >
          <!-- <i class="ti ti-calculator"></i> -->
          Calcular
        </button>
      </div>

      <!-- SALVAR -->
      <div class="col-6 col-md-auto">
        <button
          class="bbotao-azul btn btn-primary w-100"
          @click="salvarCalculo()"
        >
          <i class="ti ti-save"></i>
          Salvar
        </button>
      </div>

    </div>

    <EllipsoidalHeadPressConcaveCalculatorComponent :ellipsoidalHeadPressConcaveCalculatorProps="ellipsoidalHeadPressConcaveCalculator" :designData="designData" :posicao="calculo.posicao" ref="ellipsoidalHeadPressConcaveCalculatorForm" @temperatura-fora-faixa="abrirAlertaTemperaturaForaFaixa"/>

    <!-- BOTÕES DE AÇÃO -->
    <div class="row g-2 justify-content-end">

      <!-- RESULTADOS -->
      <div class="col-12 col-md-auto">
        <button
          type="submit"
          class="botao-azul btn btn-primary w-100"
          @click="verResultados()"
        >
          <!-- <i class="ti ti-calculator"></i> -->
          Ver Resultados
        </button>
      </div>

      <!-- CALCULAR -->
      <div class="col-12 col-md-auto">
        <button
          type="button"
          class="botao-azul btn btn-primary w-100"
          @click="calcular"
        >
          <!-- <i class="ti ti-calculator"></i> -->
          Calcular
        </button>
      </div>

      <!-- SALVAR -->
      <div class="col-6 col-md-auto">
        <button
          class="botao-azul btn btn-primary w-100"
          @click="salvarCalculo()"
        >
          <i class="ti ti-save"></i>
          Salvar
        </button>
      </div>

    </div>
    
    <!-- MODAIS -->
    <AlertModal
      :visible="alertModal.visible"
      :title="alertModal.title"
      :message="alertModal.message"
      :type="alertModal.type"
      @close="fecharAlert"
    />

    <LoadingModal
      :visible="loading.visible"
      :title="loading.title"
      :message="loading.message"
    />

  </div>
</template>

<script>
import { getUsuario } from '@/utils/authStorage';
// Componentes
import EllipsoidalHeadPressConcaveCalculatorComponent from '@/components/calculadoras/EllipsoidalHeadPressConcaveCalculatorComponent.vue';
import DesignData from '@/models/calculadoras/DesignData.js';
import EllipsoidalHeadPressConcaveCalculator from '@/models/calculadoras/EllipsoidalHeadPressConcaveCalculator.js';
import AlertModal from '@/componentesTelas/AlertModal.vue';
import LoadingModal from '@/componentesTelas/LoadingModal.vue';
import { logoBase64 } from './imgBase64/logoBase64.js';
import { drawingEllipsoidalHeadPressConcaveBase64 } from './imgBase64/drawingEllipsoidalHeadPressConcaveBase64.js';
import { jsPDF } from "jspdf";

export default {
  name: "CalculatorShellCilindInternalPress",
  props: ["cod"],
  data() {
    return {
      calculo: {},
      designData: new DesignData(),
      ellipsoidalHeadPressConcaveCalculator: new EllipsoidalHeadPressConcaveCalculator(),
      usuarioLogado: null,

      // Modal de loading
      loadingModal: null,
      loadingModalAberto: false,

      // Modal de loading
      loading: {
        visible: false,
        title: 'Carregando dados',
        message: 'Aguarde um momento...'
      },

      // Modal genérico
      alertModal: {
        visible: false,
        title: '',
        message: '',
        type: 'info'
      },
    };
  },
  components: {
    EllipsoidalHeadPressConcaveCalculatorComponent,
    AlertModal,
    LoadingModal
  },
  mounted(){
    const usuarioSalvo = getUsuario();
    this.usuarioLogado = usuarioSalvo ? {
      ...usuarioSalvo,
      nome: usuarioSalvo.nome
    } : null;
    this.topoPagina();
    this.abrirLoading();
    this.carregarCalculo(this.cod);
  },
  created(){
    window.scrollTo(0, 0);
    this.topoPagina();
  },
  updated(){
    setTimeout(() => {
      this.topoPagina();
    }, 1);
  },
  methods: {
    
    abrirAlert(title, message, type = 'info') {
      this.alertModal = {
        visible: true,
        title,
        message,
        type
      };
    },

    abrirAlertaTemperaturaForaFaixa({ temperatura, minimo, maximo }) {
      this.abrirAlert(
        "Sistema",
        `A temperatura informada (${temperatura} °C) esta fora do intervalo permitido (${minimo} °C a ${maximo} °C).`,
        "warning"
      );
    },

    fecharAlert() {
      this.alertModal.visible = false;
    },

    abrirLoading() {
      this.loading.visible = true;
    },

    fecharLoading() {
      this.loading.visible = false;
    },

    calcular(){
      const form = this.$refs.ellipsoidalHeadPressConcaveCalculatorForm.$refs.formCalculo;

      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }

      if (!this.ellipsoidalHeadPressConcaveCalculator.nominalComposition) {
        form.querySelector('input[type="search"]')?.focus();
        return;
      }

      // Dispara o submit do form
      form.requestSubmit();

      this.abrirAlert("Sistema", "Cálculos realizados com sucesso.", "success");
    },

    verResultados() {
      // Scroll para os resultados
      this.$nextTick(() => {
        const el = document.getElementById('calculation-results');
        if (el) {
          el.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      });
    },

    abreviarNome(nome) {
      if (!nome) return '';

      const partes = nome
        .trim()
        .split(' ')
        .filter(Boolean); // 🔑 remove strings vazias

      if (partes.length === 1) return partes[0];

      return `${partes[0]} ${partes[partes.length - 1]}`;
    },

    converterDataBrasil(data) {
      if (!data) return '';

      const partes = data.split('-');
      if (partes.length !== 3) return data;

      return `${partes[2]}/${partes[1]}/${partes[0]}`;
    },

    topoPagina() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },

    async carregarDesignDataPorCod(codProjeto) {
      try {
          const response = await fetch(
              `${process.env.VUE_APP_BACKEND_URL}/buscar-design-data/${codProjeto}`,
              {
                  method: "GET",
                  headers: { "Content-Type": "application/json" }
              }
          );

          if (!response.ok) {
              throw new Error("Design Data não encontrado");
          }

          const data = await response.json();

          // mantém a instância da classe DesignData
          Object.assign(this.designData, data.designData.designData);

          // Atualiza a temperatura de projeto
          this.ellipsoidalHeadPressConcaveCalculator.designTemperature = this.designData.designTemperature;
          this.ellipsoidalHeadPressConcaveCalculator.density = this.designData.density;

      } catch (error) {
          console.error("Erro ao carregar Design Data:", error);
      }
    },

    salvarCalculo() {
      let calculo = {
        cod: this.cod,
        ellipsoidalHeadPressConcaveCalculator: this.ellipsoidalHeadPressConcaveCalculator,
      };

      fetch(`${process.env.VUE_APP_BACKEND_URL}/salvar-calculo`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ calculo }),
        mode: 'cors',
      })
        .then(response => response.json())
        .then(() => {
          this.abrirAlert("Sistema", "Dados salvos com sucesso.", "info");
          this.topoPagina();
        })
        .catch(error => {
          console.error('Erro ao enviar dados para o servidor:', error);
        });
    },
    
    carregarCalculo(cod) {

      fetch(
        `${process.env.VUE_APP_BACKEND_URL}/buscar-calculo/${cod}?email=${this.usuarioLogado.email}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
          mode: "cors",
        }
      )
        .then((response) => {

          // 🔐 BACKEND decide o acesso
          if (response.status === 401 || response.status === 403) {
            window.location.href = '/';
            throw new Error('Acesso negado');
          }

          if (!response.ok) {
            throw new Error('Erro ao carregar cálculo');
          }

          return response.json();
        })
        .then((data) => {
          if (!data || !data.calculo) {
            console.error("Resposta inválida do servidor:", data);
            return;
          }

          // 1️⃣ CÁLCULO
          Object.assign(this.calculo, data.calculo);

          // 2️⃣ DADOS ESPECÍFICOS DO CALCULADOR
          Object.assign(
            this.ellipsoidalHeadPressConcaveCalculator,
            data.calculo.ellipsoidalHeadPressConcaveCalculator
          );

          // 3️⃣ DESIGN DATA PELO PROJETO
          this.carregarDesignDataPorCod(this.calculo.codProjeto);

          this.topoPagina();
        })
        .catch((error) => {
          console.error("Erro ao carregar dados do cálculo:", error);
        })
        .finally(() => {
          this.fecharLoading();
        });
    },

    adicionarPaginacao(doc) {
      const totalPaginas = doc.internal.getNumberOfPages();
      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.height;

      for (let i = 1; i <= totalPaginas; i++) {
        doc.setPage(i);
        doc.setFont("helvetica", "normal");
        doc.setFontSize(10);
        doc.setTextColor(150);

        const texto = `Página ${i} de ${totalPaginas}`;
        const textWidth = doc.getTextWidth(texto);
        doc.text(texto, (pageWidth - textWidth) / 2, pageHeight - 10);

        doc.setTextColor(0);
      }
    },

    async imprimir() {
      this.loading = {
        visible: true,
        title: 'Gerando PDF',
        message: 'Aguarde enquanto o documento e preparado...'
      };
      await this.$nextTick();
      await new Promise(resolve => requestAnimationFrame(resolve));

      const doc = new jsPDF();

      /* =========================
        FONTES
      ========================== */
      const pageHeight = doc.internal.pageSize.height;
      const pageWidth = doc.internal.pageSize.getWidth();
      let y = 20;

      /* =========================
        PAGE BREAK
      ========================== */
      const checkPage = (extra = 10) => {
        if (y + extra >= pageHeight - 20) {
          doc.addPage();
          y = 20;
        }
      };

      /* =========================
        HELPERS
      ========================== */
      const title = (text) => {
        checkPage(20);
        doc.setFont("helvetica", "bold");
        doc.setFontSize(16);
        doc.text(text, 20, y);
        y += 14;
      };

      // 🔥 subtitle com espaçamento FIXO de 15
      const subtitle = (text) => {
        checkPage(15);
        doc.setFont("helvetica", "bold");
        doc.setFontSize(14);
        doc.text(text, 20, y);
        y += 15;
      };

      const field = (label, value, unit = "") => {
        checkPage();

        doc.setFont("helvetica", "bold");
        doc.setFontSize(14);
        doc.text(label, 20, y);

        let x = 20 + doc.getTextWidth(label);

        doc.setFont("helvetica", "normal");
        doc.text(":", x, y);
        x += doc.getTextWidth(": ");

        doc.text(
          `${value ?? "N/A"}${unit ? " " + unit : ""}`,
          x + 2,
          y
        );

        y += 10;
      };

      /* =========================
        HEADER
      ========================== */
      const logoW = 55;
      const logoH = 12;
      const logoX = (pageWidth - logoW) / 2;

      doc.addImage(logoBase64, "PNG", logoX, y, logoW, logoH);
      doc.link(logoX, y, logoW, logoH, {
        url: "https://wisecalc.com.br",
      });

      y += logoH + 25;

      doc.setFont("helvetica", "bold");
      doc.setFontSize(18);
      doc.text("Ellipsoidal Head Press Concave", 20, y);
      y += 14;

      field("Nome do Componente", this.calculo.nomeCalculo);
      field("Tipo de Calculadora", this.calculo.nomeCalculadora);
      field("Autor(a)", this.calculo.autor || "N/A");

      field(
        "Data da Impressão",
        new Date().toLocaleDateString("pt-BR", {
          weekday: "long",
          year: "numeric",
          month: "long",
          day: "numeric",
        })
      );

      /* =========================
        1. DESIGN DATA
      ========================== */
      y += 10;
      title("1. DESIGN DATA");

      const f = this.ellipsoidalHeadPressConcaveCalculator;

      subtitle("MATERIAL");

      field("Material Specification (ASME II part D)", f.materialSpecification?.materialSpecification);
      field("Nominal Composition", f.nominalComposition);
      field("Product Form", f.productForm);
      field("Alloy Designation/UNS No.", f.alloyDesignation);
      field("Class/Condition/Temper", f.classConditionTemper);
      field("P-No.", f.pNo);
      field("Group No.", f.groupNo);

      y += 5;
      subtitle("MECHANICAL PROPERTIES");

      field("Min. Tensile Strength", f.minTensileStrength, "MPa");
      field("Min. Yield Strength", f.minYieldStrength, "MPa");

      y += 5;
      subtitle("TEMPERATURE");

      field("VIII-1 Applic. and Max Temp. Limit", f.viiiApplicAndMaxTemLimit, "°C");
      field("Range Design Temperature", f.rangeDesignTemperature, "°C");

      y += 5;
      subtitle("GEOMETRY");

      field("Inside Diameter", f.insideDiameter, "mm");
      field("Liquid Column", f.liquidColumn, "m");
      field("Fluid Density", f.fluidDensity, "kg/m³");

      y += 5;
      subtitle("PRESSURE");

      field("Design Pressure on the Top of the Vessel", f.designPressureTop, "MPa");
      field("Design Pressure", f.designPressure, "MPa");

      y += 5;
      subtitle("STRESS");

      field("Admissible Stress @ Design Temperature", f.admissibleStressDesignTemp, "MPa");
      field("Admissible Stress @ Room Temperature", f.admissibleStressRoomTemp, "MPa");

      y += 5;
      subtitle("DIMENSIONS");

      field("Inside Radius", f.insideRadius, "mm");
      field("Inside Radius Corroded", f.insideRadiusCorroded, "mm");
      field("Corrosion Allowance", f.corrosionAllowance, "mm");
      field("Nominal Thickness minus Corrosion Allowance", f.nominalThicknessMinusCorrosionAloowance, "mm");
      field("Nominal Thickness", f.nominalThickness, "mm");

      y += 5;
      subtitle("CONSTRUCTION");

      field("Welded Joint Location", f.weldedJointLocation);

      /* =========================
        2. DESIGN VALIDATION
      ========================== */
      y += 10;
      title("2. DESIGN VALIDATION");

      // imagem
      // y += 10;
      const drawingWidth = 80;
      const drawingHeight = 60;
      const drawingX = (pageWidth - drawingWidth) / 2;

      checkPage(drawingHeight + 20);
      doc.addImage(drawingEllipsoidalHeadPressConcaveBase64, "PNG", drawingX, y, drawingWidth, drawingHeight);
      y += drawingHeight + 20;

      subtitle("RESULTS");

      const redIfInvalid = (value, unit = "") => {
        checkPage();

        doc.setFont("helvetica", "bold");
        doc.text(value.label, 20, y);

        let x = 20 + doc.getTextWidth(value.label);

        doc.setFont("helvetica", "normal");
        doc.text(":", x, y);
        x += doc.getTextWidth(": ");

        if (value.val === "INVALID NOMINAL THICKNESS") {
          doc.setTextColor(255, 0, 0);
          doc.text(value.val, x + 2, y);
        } else {
          doc.setTextColor(0, 0, 0);
          doc.text(`${value.val ?? "N/A"}${unit}`, x + 2, y);
        }

        doc.setTextColor(0, 0, 0);
        y += 10;
      };

      redIfInvalid(
        { label: "Design Thickness", val: f.designThickness },
        " mm"
      );

      redIfInvalid(
        { label: "Working Maximum Allowable Pressure", val: f.workingMaximumAllowablePressure },
        " MPa"
      );

      redIfInvalid(
        { label: "Hydrostatic Test Pressure", val: f.hidrostaticTestPressure },
        " MPa"
      );

      redIfInvalid(
        { label: "Pneumatic Test Pressure", val: f.pneumaticTestPressure },
        " MPa"
      );

      /* =========================
        SAVE
      ========================== */
      this.adicionarPaginacao(doc);
      doc.save(`(WISECALC) ${this.calculo.nomeCalculo}.pdf`);
      this.fecharLoading();
    }

  }
};
</script>

<style scoped>
.documento {
  width: 210mm;
  min-height: 297mm;
  padding: 20mm;
  background: white;
  font-family: 'Arial', sans-serif;
  font-size: 14px;
  position: relative;
  box-sizing: border-box;
}

.cabecalho {
  text-align: center;
  border-bottom: 2px solid #000;
  margin-bottom: 20px;
}

.cabecalho .logo {
  width: 80px;
  margin-bottom: 10px;
}

.conteudo {
  margin-top: 20px;
}

.conteudo p {
  margin-bottom: 10px;
}

.rodape {
  position: absolute;
  bottom: 20mm;
  left: 0;
  width: 100%;
  text-align: center;
  font-size: 12px;
  color: gray;
  border-top: 1px solid #ccc;
  padding-top: 5px;
}

.botao-outline-azul{
  border-color: #0056FF;
  background-color: white;
  color: #0056FF;
  font-weight: 600;
  height: 40px !important;
}

.botao-outline-azul:hover{
  border-color: #0056FF;
  background-color: #0056FF;
  color: white;
  font-weight: 600;
}

.img-componente-calc{
  width: 150px;
}

/* APENAS CELULAR */
@media (max-width: 575px) {
    .input {
        width: 150px;
    }

    .form-select{
        display: block !important;
    }

    .img-componente-calc{
      width: 150px;
    }
}

/* TABLET */
@media (min-width: 768px) and (max-width: 991px) {
    .img-componente-calc{
      width: 125px;
    }
}
</style>